import request from '@/router/axios';

let urlPrefix = '/api/io/labexpreservationlog';

/**
 * 学生添加预约
 */
export const getAddReserva = (data) => {
    return request(`${urlPrefix}`, {
        data
    }, "post");
};

/**
 * 学生查询预约
 */
export const getStudyReservaQuery = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit
        }
    });
};

/**
 * 学生拖拽时编辑预约 
 */
export const getPutReserva = data => {
    return request(`${urlPrefix}`, {
        data
    }, 'put');
};

/**
 * 学生删除预约记录
 */
export const getDelReserva = id => {
    return request(`${urlPrefix}/${id}`, null, 'delete');
};